import {
  FaUsers,
  FaFire,
  FaBolt,
  FaStar,
  FaQuestionCircle,
} from "react-icons/fa";

export const FEED_SOURCE_FILTERS = [
  {
    id: "forYou",
    label: "Community",
    icon: FaStar,
    title: "All community posts ranked for you — every type, tailored to your interests",
  },
  {
    id: "following",
    label: "Following",
    icon: FaUsers,
    title: "Posts from people you follow",
  },
];

export const FEED_FILTERS = [
  {
    id: "battles",
    label: "Battles",
    icon: FaBolt,
    title: "Community-voted product battles",
    isBattles: true,
  },
  {
    id: "flex",
    label: "Flex",
    icon: FaFire,
    title: "Show off your tech — community setups and gear",
    isFlex: true,
  },
  {
    id: "ask",
    label: "Ask",
    icon: FaQuestionCircle,
    title: "Community questions — get answers from owners and experts",
    isAsk: true,
  },
];

export const FEED_TAB_PARAM = "tab";
export const FEED_SOURCE_PARAM = "source";
export const MATCH_SESSION_PARAM = "matchSession";

/** Content view tabs (Battles, Flex, Ask, My matches) */
export const VALID_FEED_TAB_TOKENS = new Set([
  "matches",
  "battles",
  "flex",
  "ask",
]);

/** Home source filters (Community, Following) — separate from content tab */
export const VALID_FEED_SOURCE_TOKENS = new Set(["forYou", "following"]);

const LEGACY_SOURCE_TAB_TOKENS = new Set(["forYou", "following"]);

export const resolveFeedTabToken = (raw) =>
  raw && VALID_FEED_TAB_TOKENS.has(raw) ? raw : null;

export const readFeedTabToken = (search) => {
  const raw = search.get(FEED_TAB_PARAM);
  if (raw && LEGACY_SOURCE_TAB_TOKENS.has(raw)) return null;
  return resolveFeedTabToken(raw);
};

export const resolveFeedSourceToken = (raw) =>
  raw && VALID_FEED_SOURCE_TOKENS.has(raw) ? raw : "forYou";

export const readFeedSourceToken = (search) => {
  const legacyTab = search.get(FEED_TAB_PARAM);
  if (legacyTab && LEGACY_SOURCE_TAB_TOKENS.has(legacyTab)) {
    return resolveFeedSourceToken(legacyTab);
  }
  return resolveFeedSourceToken(search.get(FEED_SOURCE_PARAM));
};

export const isLegacySourceTabToken = (raw) =>
  Boolean(raw && LEGACY_SOURCE_TAB_TOKENS.has(raw));

/** Home source filter (Community / Following) — not active on My matches */
export const isFeedSourceFilterActive = (
  filterId,
  activeFilter,
  _activeTab,
  showingMatches = false,
) => !showingMatches && activeFilter === filterId;
